<template>
	<div style="text-align: center">
		<b-container class="text-left" v-html="$t('pyme.text', PRIVACY_POLICY_COMPANY_DATA)">
  		</b-container>
  		<img class="pyme" src="/static-appopensalud/img/logos/pyme.png"/>
	</div>
</template>

<script>
import { PRIVACY_POLICY_COMPANY_DATA } from '@/constants/companyCommonData'

export default {
	data () {
		return {
			PRIVACY_POLICY_COMPANY_DATA
		}
	}
}
</script>

<style lang="scss" scoped>
	/deep/ li {
		list-style: inherit !important;
	}
	.pyme {
		width: 50%;
		@include mobile{
			width: 90%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/Pyme.vue